// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"432":"60ef2c56","699":"b1ea8683","898":"68841fd8"}[chunkId] + ".js";
};